module.exports = __webpack_public_path__ + "img/terravera.ed80b799.png";